class MFRHostedVideo {
  constructor(index, element) {
    this.$index = index;
    this.$element = $(element);

    if( this.$element.hasClass( "rendered" ) ) return;

    this.init();
    this.$element.addClass("rendered");
  }

  init() {
    this.$video = this.$element.find("video");
    this.$cover = this.$element.find(".mfr-components__video-custom-poster");
    this.$playPauseButton = this.$element.find(".mfr-components__video-icon");
    this.$playPauseButtonV2 = this.$element.find(".play-pause-button");
    this.$speakerButton = this.$element.find(".speaker-button");

    this.$video.on("play", this.__handleVideoPlay.bind(this));
    this.$video.on("pause", this.__handleVideoPause.bind(this));

    this.$cover.on("click", this.__handleVideoClick.bind(this));
    this.$video
      .on("click", this.__handleVideoClick.bind(this))
      .on("volumechange", this.__handleVideoVolumeChange.bind(this));
    // this.$video.on("volumechange", this.__handleVideoVolumeChange.bind(this));
    

    this.$playPauseButtonV2.on("click", this.__handleControlClick.bind(this));
    this.$speakerButton.on("click", this.__handleSpeakerButtonClick.bind(this));
  }

  __handleVideoPlay(e) {
    this.$playPauseButtonV2.removeClass("play pause").addClass("pause");
    this.$element.toggleClass("is-playing", !e.currentTarget.paused);
    this.$element.toggleClass("is-muted", e.currentTarget.muted);
  }

  __handleVideoPause(e) {
    this.$playPauseButtonV2.removeClass("play pause").addClass("play");
    this.$element.toggleClass("is-playing", !e.currentTarget.paused);
    this.$element.toggleClass("is-muted", e.currentTarget.muted);
  }

  __handleVideoClick(e) {
    if ($(e.currentTarget).attr("controls")) return;

    // Get the actual video DOM element from the jQuery object
    let videoElement = this.$video.get(0);
    if (videoElement.paused) videoElement.play();
    else videoElement.pause();

    // if( e.currentTarget.paused )
    //     e.currentTarget.play()
    // else
    //     e.currentTarget.pause();
  }

  __handleControlClick(e) {
    let videoElement = this.$video.get(0);
    if (this.$playPauseButtonV2.hasClass("pause")) {
      videoElement.pause();
    } else {
      videoElement.play();
    }
  }

  __handleVideoVolumeChange(e) {
    this.$element.toggleClass("is-muted", e.currentTarget.muted);
  }

  __handleSpeakerButtonClick(e) {
    this.$video.get(0).muted = !this.$video.get(0).muted;
  }
}